var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDowloadmanualIcon = function SvgDowloadmanualIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.2,
    height: 24,
    viewBox: "0 0 19.2 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760",
    transform: "translate(-211 -4034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "upload_file_FILL0_wght400_GRAD0_opsz48",
    d: "M8,28V4H20.63l6.57,6.57V28ZM19.73,11.38V5.8H9.8V26.2H25.4V11.38ZM9.8,5.8v0Z",
    transform: "translate(203 4030)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "upload_file_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "upload_file_FILL0_wght400_GRAD0_opsz48",
    d: "M3.448,8.565H5.089v-5.5L7.333,5.308,8.482,4.159,4.214,0,0,4.214,1.149,5.363l2.3-2.3Z",
    transform: "translate(224.841 4054.133) rotate(180)",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDowloadmanualIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dowloadmanual_icon.48b86ea9f5807c4b6c91bf550e6a3bfc.svg";